import { render, staticRenderFns } from "./LogisticsInfoDialog.vue?vue&type=template&id=73dd134f&scoped=true&"
import script from "./LogisticsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./LogisticsInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsInfoDialog.vue?vue&type=style&index=0&id=73dd134f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd134f",
  null
  
)

export default component.exports